const buildParams = (filter) => {
  const params = {};

  Object.entries(filter || {}).forEach(([key, value]) => {
    // flatten nested object (like filterType)
    if (typeof value === "object" && value !== null && !Array.isArray(value)) {
      Object.entries(value).forEach(([innerKey, innerValue]) => {
        if (
          innerValue !== "" &&
          innerValue !== null &&
          innerValue !== undefined
        ) {
          params[innerKey] = innerValue;
        }
      });
    } else {
      if (value !== "" && value !== null && value !== undefined) {
        params[key] = value;
      }
    }
  });

  return params;
};

export default buildParams;